import { fetchCA } from 'helpers/utils'

export const apiFetchFaq = (id) => fetchCA(`/faq/${id}`)

export const apiFetchFaqByPhone = (phoneId) =>
  fetchCA('/faqByPhone', { phoneId })
